import { INFERENCES_DSAT_FEATURE } from '../../helpers/FeatureFlagName';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isInferencesDSATSupported(): boolean {
    return isFeatureEnabled(INFERENCES_DSAT_FEATURE);
}
